<template>
  <div class="wait_buy">
    <div class="topBar">
      <div class="subTitle">
        <i class="far fa-window-minimize icon_I"></i>
        等待采购列表
        <div @click="setPage(1)" class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div class="margin_left_x">刷新</div>
        </div>
      </div>
    </div>
    <div v-if="role" class="content_box">
      <div class="table_title">
        <div class="table_title_box">
          <div class="title_icon">
            <i class="fas fa-bars"></i>
          </div>
          <div class="title_text">数据列表</div>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
          <el-table-column prop="orderCode" width="200" label="订单编号" align="center"></el-table-column>
          <el-table-column width="500" label="商品信息" >
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.product_list" :key="index">{{item.title}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" width="170" label="下单时间" align="center"></el-table-column>
          <el-table-column prop="finance_check" width="100" label="审核" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="
                purchase(scope.row.orderCode),
                purchaseInfo(scope.row.orderCode),
                getSupplier()"
              >采购</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="page_box clearfix">
        <div class="page">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="15"
            :current-page.sync="page"
            @current-change="setPage"
          ></el-pagination>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 确认采购 -->
    <el-dialog title="确认采购" :visible.sync="show_purchase_form" width="95%">
      <el-form>
        <el-form-item label="订单编号:">
          <el-input
            style="width:500px"
            v-model="purchase_orderCode"
            autocomplete="off"
            :disabled="true"
          ></el-input>
        </el-form-item>
      </el-form>
      <div>
        <el-table :data="purchaseData" ref="multipleTable"  @selection-change="handleSelectionChange" border type="index" style="width: 100%">
          <el-table-column
            type="selection"
            :selectable = filterCheck
            width="50">
          </el-table-column>
          <el-table-column prop="title" label="名称"></el-table-column>
          <el-table-column prop="item_no" label="货号"></el-table-column>
          <el-table-column prop="specification" label="规格"></el-table-column>
          <el-table-column prop="brand" label="品牌"></el-table-column>
          <!-- <el-table-column label="名称" width="180">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].title"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="货号">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].item_no"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="规格">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].specification"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="品牌">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].brand"></el-input>
            </template>
          </el-table-column> -->
          <el-table-column prop="inventory" label="库存" width="50"></el-table-column>
          <el-table-column prop="create_time" label="下单时间" width="100"></el-table-column>
          <el-table-column label="供应商" width="150">
            <template slot-scope="scope">
              <el-autocomplete
                style="width:100%"
                v-model="purchaseData[scope.$index].supplier"
                :fetch-suggestions="querySearchAsync"
                @select="supplierSelect"
              ></el-autocomplete>
            </template>
          </el-table-column>
          <!-- <el-table-column label="数量(总)">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].number"></el-input>
            </template>
          </el-table-column> -->
          <el-table-column prop="number" label="数量(总)" align="center"></el-table-column>
          <el-table-column label="数量(采购)">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].real_number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="价格">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].purchasePrice"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="总价">
              <template slot-scope="scope">
                {{ totalPrice(scope.$index) }}
              </template>
          </el-table-column>
          <el-table-column label="到货期">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].days" placeholder="单位天"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="实际到货期">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].real_days" placeholder="单位天"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="发票号" width="150">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].duty_remark"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="250">
            <template slot-scope="scope">
              <el-input v-model="purchaseData[scope.$index].remark"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show_purchase_form = false">取 消</el-button>
        <el-button type="primary" @click="confirm_purchase()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "./../../assets/all.css";
export default {
  name: "wait",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      tableData: [],
      page: 1,
      total: 0,
      show_purchase_form: false,
      purchaseData: [],
      purchase_orderCode: "",
      supplierSelect: [],
      restaurants: [],
      multipleItemno: [],//多选框值
      real_number:[]
    };
  },
  created() {
    this.$store.state.topActiveId = 12;
    this.$store.state.leftTitle = "待采购订单";
    this.geting();
  },
  computed: {
    totalPrice() {  //总价计算
        return function(index) {
          var total = this.purchaseData[index].real_number * this.purchaseData[index].purchasePrice;
          if(isNaN(total)){
            return '';
          }else{
            return total.toFixed(2);
          }
          
        }
    }
  },
  methods: {
    handleSelectionChange(val) { //多选框选值
      this.multipleItemno = val;
    },
    filterCheck (row) {  //筛选多选只能是未结算的条件才可已进行勾选
      if(row.disabled == 0){
        return true;
      }
    },
    getSupplier(name) {
      this.axios
        .get(this.serve + "/admin/get_supplier_list", {
          params: {
            name: name,
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          var data = res.data;
          console.log(data);
          if (data.status == "success") {
            var row = [];
            var data1 = data.data;
            for (var i in data1) {
              var a = {};
              a.value = data1[i];
              row[i] = a;
            }
            this.restaurants = row;
          } else {
            this.restaurants = [];
          }
        });
    },
    querySearchAsync(queryString, cb) {
      console.log(queryString);
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      cb(results);
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    confirm_purchase() {
      var qs = require("qs");
      
      if(this.multipleItemno.length > 0){
        
        var purchaseArr = [];
        for(let i=0;i<this.purchaseData.length;i++){
           var purceprice = parseInt(this.purchaseData[i]['purchasePrice']);
           if(!Number.isNaN(purceprice) && purceprice > 0  && this.multipleItemno.indexOf(this.purchaseData[i]['item_no'])){
              purchaseArr.push(this.purchaseData[i])
           }
        }

        if(purchaseArr.length > 0){
          var formData = {
            username: this.username,
            token: this.token,
            orderCode: this.purchase_orderCode,
            order_info: JSON.stringify(purchaseArr)
          };
          const loading = this.$loading({
            lock: true,
            text: "数据处理中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
           this.axios
            .post(this.serve + "/admin/buy_product", qs.stringify(formData))
            .then(res => {
              if (res.data.status == "success") {
                this.show_purchase_form = false;
                this.geting(this.page);
                this.$message({
                  type: "success",
                  message: "采购成功!",
                  offset: 200
                });
              } else if (res.data.status == "error") {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                  offset: 200
                });
              }
              loading.close();
            });
        }else{
          this.$message.error('商品价格必填！');
        }
      }else{
        this.$message.error('请勾选要采购的商品！');
      }
    },
    setPage(v) {
      this.geting(v);
      this.page = v;
    },
    purchase(orderCode) {
      this.purchase_orderCode = orderCode;
      this.show_purchase_form = true;
    },
    purchaseInfo(orderCode) {
      this.axios
        .get(this.serve + "/admin/purchaseInfo", {
          params: {
            username: this.username,
            token: this.token,
            orderCode: orderCode
          }
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.purchaseData = data.data;
          } else {
            this.purchaseData = [];
          }
        });
    },
    geting(page = 1) {
      var where = {
        username: this.username,
        token: this.token,
        page: page
      };
      this.axios
        .get(this.serve + "/admin/wait_buy_order", {
          params: where
        })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.tableData = data.data.results;
            this.total = data.data.total;
          } else {
            if(data.msg == "无权访问"){
              this.role =  false
            }
            this.tableData = [];
          }
        });
    }
  }
};
</script>

<style  lang="scss">
</style>